/**
 * How many names a confirmation prints before it starts counting instead.
 *
 * Three is enough to recognise what is about to be affected and short enough
 * that a phase with twenty steps does not produce a dialog the size of the
 * canvas behind it.
 */
export const NAME_LIST_CAP = 3;

/**
 * A readable list of names, capped.
 *
 * Shared by the two destructive confirmations — a phase taking its steps to
 * Unassigned, and a workflow taking its tasks with it — because the cap and the
 * "…and N more" wording are the same decision in both, and two copies would
 * drift the first time either was tuned.
 *
 * Returns the empty string for no names at all. Callers never render it in that
 * case: a dialog with nothing to list says something different in prose, rather
 * than an empty sentence with a full stop after it.
 */
export function nameList(
  names: ReadonlyArray<string>,
  cap: number = NAME_LIST_CAP,
): string {
  if (names.length === 0) return '';
  if (names.length <= cap) return names.join(', ');

  const shown = names.slice(0, cap).join(', ');
  const rest = names.length - cap;
  return `${shown}, and ${String(rest)} more`;
}
